/* Removed the tab index from the element used to delete the text inside inputs */
export default {
  mounted() {
    const elements = document.getElementsByClassName('fa-times');
    for (let i = 0; i < elements.length; i++) {
      elements[i].tabIndex = -1;
    }
  },
};
